import { render } from "./LeadEdit.vue?vue&type=template&id=20969c08"
import script from "./LeadEdit.vue?vue&type=script&lang=js"
export * from "./LeadEdit.vue?vue&type=script&lang=js"

import "./LeadEdit.vue?vue&type=style&index=0&id=20969c08&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__